<template>
    <div id="app">
        <router-view></router-view>
        <BackToHome v-if="showBackToHome"/>
    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
        BackToHome(render) {
            require(["@/components/common/BackToHome"], render)
        },
    },
    computed:{
        showBackToHome(){
            return !~["Login", "Home"].indexOf(this.$route.name) ? true : false;
        }
    }
}
</script>

<style>
#app {
    /*font-family: "Noto Sans SC", Avenir, Helvetica, Arial, sans-serif;*/
    font-family: PingFangSC-Regular, PingFang SC;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    text-align: justify;
}
</style>
